import { move } from '@store/reducers/dashboard/saga/folders/move'
import { all, takeEvery, takeLatest } from 'redux-saga/effects'

import { DashboardActions, FolderAccessRequestAction } from '../../actions'
import { create } from './create'
import { deleteSaga } from './delete'
import { folderAccessRequest } from './folderAccessRequest'
import { rename } from './rename'
import { updateMemberAccess } from './updateMemberAccess'
import { updateVisibility } from './updateVisibility'

export function* foldersSaga() {
  yield all([
    takeLatest(FolderAccessRequestAction, folderAccessRequest),
    takeEvery(DashboardActions.folders.create, create),
    takeEvery(DashboardActions.folders.updateVisibility, updateVisibility),
    takeEvery(DashboardActions.folders.updateMemberAccess, updateMemberAccess),
    takeEvery(DashboardActions.folders.delete, deleteSaga),
    takeEvery(DashboardActions.folders.rename, rename),
    takeEvery(DashboardActions.folders.move, move),
  ])
}
